import { GetCommonServiceToken } from "../../helpers/Util";
import { fetchInstance } from "../../helpers/interceptor";

export const deleteFileForEhr = async (ehrImageId, caseId, companyId, fileName) => {
    const payload = {
        ImageId:   ehrImageId,    
        CompanyId: companyId,     
        CaseId:    caseId,        
        FileName:  fileName ?? "" 
    };
    
    try {
        const response = await PostWithCommon(
            `${process.env.REACT_APP_COMMONSERVICE_URL}Document/DeleteFile`, 
            payload
        );

        //  Read and log the actual response
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("=== EHR delete FAILED:", err);
        throw err;
    }
};

export const PostWithCommon = async (url, data, formData) => {
    let CommonServiceToken = GetCommonServiceToken();
    return await fetchInstance(url, {
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": formData ? "multipart/form-data; boundary=2345678998765432" : "application/json",
            Authorization: "Bearer " + CommonServiceToken,
        },
        body: formData ? data : JSON.stringify(data),
    })
}

export const CallApiForSetEhrImageId = async (documentId, ehrImageId) => {
  try {
    const response = await fetchInstance(
      `${process.env.REACT_APP_LAW_API_URL}Document/set-ehr-image-id`,
    // `https://localhost:7092/api/Document/set-ehr-image-id`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Env: process.env.REACT_APP_ENVIRONMENT,
        },
        body: JSON.stringify({ documentId, ehrImageId }),
      }
    );

    const data = await response.json();

    if (data.success) {
      return { success: true };
    } else {
      return { success: false, message: data.message || "Failed to set EHR image ID" };
    }
  } catch (error) {
    return { success: false, message: error.message || "Error setting EHR image ID" };
  }
};